module.exports = __webpack_public_path__ + "img/default@2x.a408aabc.png";